import { css, type ExecutionContext } from 'styled-components'

type CustomExtendedProps = {
  monospace?: boolean
  uppercase?: boolean
  capitalize?: boolean
  ellipsis?: boolean
  nowrap?: boolean
  preWrap?: boolean
}

const monospaceCss = ({
  monospace,
}: ExecutionContext & { monospace?: boolean }) =>
  monospace &&
  css`
    font-feature-settings: 'tnum' on, 'lnum' on;
  `

const uppercaseCss = ({
  uppercase,
}: ExecutionContext & { uppercase?: boolean }) =>
  uppercase &&
  css`
    text-transform: uppercase;
  `

const capitalizeCss = ({
  capitalize,
}: ExecutionContext & { capitalize?: boolean }) =>
  capitalize &&
  css`
    text-transform: capitalize;
  `

const ellipsisCss = ({ ellipsis }: ExecutionContext & { ellipsis?: boolean }) =>
  ellipsis &&
  css`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `

const nowrapCss = ({ nowrap }: ExecutionContext & { nowrap?: boolean }) =>
  nowrap &&
  css`
    white-space: nowrap;
  `

const preWrapCss = ({ preWrap }: ExecutionContext & { preWrap?: boolean }) =>
  preWrap &&
  css`
    white-space: pre-wrap;
  `

export type { CustomExtendedProps }
export {
  capitalizeCss,
  ellipsisCss,
  monospaceCss,
  nowrapCss,
  preWrapCss,
  uppercaseCss,
}
